import { render, staticRenderFns } from "./dailyWritingPage.vue?vue&type=template&id=58da3a1a&scoped=true&"
import script from "./dailyWritingPage.vue?vue&type=script&lang=js&"
export * from "./dailyWritingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58da3a1a",
  null
  
)

export default component.exports